<script lang="ts" setup>
import { useTranslate } from '@tolgee/vue'

import { PLAN_TYPES, type PlanType } from '@/api/interfaces'

interface Props {
  plan: PlanType
}

withDefaults(defineProps<Props>(), {
  plan: PLAN_TYPES.GROWTH,
})

const { t } = useTranslate('local')

const upgradePlanUrl = `${import.meta.env.VITE_FRONTEND_URL}/upgrade-plan`
</script>

<template>
  <GsButton class="mt-3" :href="upgradePlanUrl" target="_blank" type="tertiary" full-width>
    {{ t(`EditorSettings.upgradePlan.${plan}`) }}
  </GsButton>
</template>
